<template>



  <div class="container">
      <h3 class="heading">المدينة</h3>

      <form @submit.prevent="postinfo">
  <div class="mb-3 input-in-con">
    <div v-if="err">
  <div v-if="err.name_ar"  class="alert alert-danger" role="alert"> {{ err.name_ar[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">اسم المدينة</label>
  <input type="text" class="form-control" id="exampleFormControlInput1" placeholder="ادخل اسم المدينة " v-model="formdata.name_ar">
</div>
     

  <div class="mb-3 input-in-con  ">
           <div v-if="err">
  <div v-if="err.directorate"  class="alert alert-danger" role="alert"> {{ err.directorate[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">المديرية</label>
 <select class="form-select " aria-label="Default select example" v-model="formdata.directorate" >
  <option disabled selected>اختر المديرية</option>
  <option  v-for="key in formdata2" :value="key.id" >{{key.name_ar}}</option>
</select>
</div>

<div class="flex last">
  <button  class="btn btn-primary">اضافة</button>
</div>
      </form>

  </div>




</template>

<script>
import  geturl  from "@/comp/geturl";

export default {
name: "AddCity",
data(){
  return{
    formdata:{
      directorates: null,
      name_ar: '',
      directorate_name: '',
    },
     formdata2:null,
     temformdata2 :null,
     err:null
    
  }
},
mounted(){


    
       fetch(geturl()+"directorate/", {
      
      headers: {"Content-Type": "application/json"},
      })
      .then(res => res.json())
      .then(data => {this.formdata2 = data
      })
    
},
methods: {
    postinfo(){

/*this.temformdata2 = this.formdata2.filter((e) => {
      if(e.name === this.formdata.directorate_name)
      return true
      else
      return false
      })
              if(this.temformdata2.length>0)
                this.formdata.directorate =  this.temformdata2[0].id*/
              

              

     
      
    fetch(geturl()+"city/", {
         method: "POST",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify(this.formdata)
      })
      .then(res => res.json())
      .then(data => { 
        if(data.error){
          this.err = data.error.details
          console.log(this.err)
                  }
      else
            this.$router.push({name:'CityView' })

      })
    },
    
}


}
</script>

<style>

</style>